import request from '@/utils/request'

// 获取日统计数据
export function getTodayReport(data) {
  return request.get('/statistical/dayReport')
}

// 获取日统计数据
export function getDayReport(params) {
  return request.get('/statistical/report', {
    params: {
      date: params.date
    }
  })
}

// 获取日统计数据
export function getMonthReport(params) {
  return request.get('/statistical/monthReport', {
    params: {
      month: params.date
    }
  })
}

// 获取日统计数据
export function getYearReport(params) {
  return request.get('/statistical/yearReport', {
    params: {
      year: params.date
    }
  })
}

// 获取日统计数据
export function getEquipmentList(data) {
  return request.get('/statistical/equipmentState')
}



//////////////////////////////////////////////////////////////////////////////
// 获取任意天的数据
export function getNdReport(params) {
  return request.get('/statistical/ndReport', { params })
}
// 获取当天统计数据
export function getDayNdReport(data) {
  return request.get('/statistical/dayNdReport')
}

// 获取月统计数据
export function getMonthNdReport(params) {
  return request.get('/statistical/monthNdReport', {
    params: {
      month: params.date
    }
  })
}

// 获取年统计数据
export function getYearNdReport(params) {
  return request.get('/statistical/yearNdReport', {
    params: {
      year: params.date
    }
  })
}